import { useHttpClient } from '@/api/httpClient.js';

const resource = 'results';

export function fetchLotteriesResults(params = {}) {
	return useHttpClient('v2').get(`/${resource}/lotteries`, {
		params
	});
}
